import { render, staticRenderFns } from "./PgtoCartao.vue?vue&type=template&id=7b7d6c68&scoped=true&"
import script from "./PgtoCartao.vue?vue&type=script&lang=js&"
export * from "./PgtoCartao.vue?vue&type=script&lang=js&"
import style0 from "./PgtoCartao.vue?vue&type=style&index=0&id=7b7d6c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7d6c68",
  null
  
)

export default component.exports